import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { doc, arrayUnion, writeBatch } from "firebase/firestore";

//const { format } = require('date-fns');
const firebaseConfig = require('./firebase.config.json');

initializeApp(firebaseConfig);
const db = getFirestore();

export async function setLettersValue(wordObject) {
    try {

        let docData = {};
        wordObject.phraseCipherValues.forEach(cv => {
            docData[cv.key] = cv.total;
        });

        const batch = writeBatch(db);

        const septenaryRef = doc(db, "septenary", docData["s"].toString());
        const ordinalRef = doc(db, "ordinal", docData["o"].toString());
        const reverseOrdinalRef = doc(db, "reverseOrdinal", docData["ro"].toString());
        const fullReductionRef = doc(db, "fullReduction", docData["fr"].toString());
        const reverseFullReduction = doc(db, "reverseFullReduction", docData["rfr"].toString());

        batch.set(septenaryRef, { word: arrayUnion(wordObject.phrase) }, { merge: true });
        batch.set(ordinalRef, { word: arrayUnion(wordObject.phrase)}, { merge: true });
        batch.set(reverseOrdinalRef, { word: arrayUnion(wordObject.phrase) }, { merge: true });
        batch.set(fullReductionRef, { word: arrayUnion(wordObject.phrase)}, { merge: true });
        batch.set(reverseFullReduction, { word: arrayUnion(wordObject.phrase) }, { merge: true });

        await batch.commit();

    } catch(error) {
        return null;
    }
}

